import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
//import TopNav from '../components/TopNav';
//import BottomTab from '../components/BottomTab';
import SimpleCalendar from '../components/SimpleCalendar';
import { FaSearch, FaCheck, FaBookOpen, FaSuitcase, FaChevronRight, FaTimes } from 'react-icons/fa';
import { FiBook, FiBookOpen, FiEdit, FiEdit2, FiEdit3 } from 'react-icons/fi';
import { PiBooks } from 'react-icons/pi';
import { useLocation, useNavigate } from 'react-router-dom';
import BookSearchHeader from '../components/BookSearchHeader';
import { Wrapper } from '../styles/CommonStyles';
import { getMyBookByIsbn, getBookcaseList, putMyBookByIsbn, putMyBookByBookId, getMyBookByBookId } from '../api/BookcaseApi';
import { getAccessToken, useInvalidateSchedules } from '../react-queries/queries';
import { processApiResponse } from '../common/errorMessage';
import { BookOwnership, ownership2text, BookStatus, ScriptStatus, bookStatus2text, scriptStatus2text } from '../common/enums';
import { BookUserInputReqDTO } from '../dto/BookcaseDTOs';
import LoadingOverlay from '../components/LoadingOverlay';
import { useNoobookContext } from '../context/NoobookContext';
import { BookRegType } from '../common/enums';
import BookSearchResultPage from './BookSearchResultPage';
import { stringToDate } from '../common/utils';
import BookCoverImage from '../components/BookCoverImage';

const CLEARED_DATE_STR = '9999.09.09';

const isEmptyDate = (dateVal) => {
  if (!dateVal) return true;
  if (dateVal instanceof Date) {
    return Number.isNaN(dateVal.getTime())
      || (dateVal.getFullYear() === 9999 && dateVal.getMonth() === 8 && dateVal.getDate() === 9);
  }
  const normalized = String(dateVal).replace(/\s/g, '');
  return /^9999[.\-/]0?9[.\-/]0?9/.test(normalized);
};

const formatDateValue = (dateVal) => {
  if (isEmptyDate(dateVal)) return null;
  if (dateVal instanceof Date) {
    return dateVal.toLocaleDateString('ko-KR', { timeZone: 'Asia/Seoul' });
  }
  return dateVal;
};

const TitleTopGap = styled.div`
  width: 100%;
  height: 12px;
  background: #f5f5f7;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #222;
  padding-top: 12px;
  margin-top: 12px;
  margin-bottom: 18px;
  text-align: left;
  padding-left: 24px;
`;

const SearchBox = styled.div`
  display: flex;
  align-items: center;
  background: #f5f5f7;
  border-radius: 10px;
  padding: 0 18px;
  margin: 0 24px 28px 24px;
  height: 48px;
  box-shadow: none;
`;

const SearchIcon = styled(FaSearch)`
  font-size: 20px;
  color: #bbb;
  margin-right: 12px;
`;

const SearchInput = styled.input`
  border: none;
  outline: none;
  font-size: 17px;
  flex: 1;
  background: transparent;
  color: #222;
  &::placeholder {
    color: #bbb;
    opacity: 1;
  }
`;

const BookInfoSection = styled.div`
  display: flex;
  align-items: center;
  padding: 0 24px 0 24px;
  margin-bottom: 18px;
`;

const BookMeta = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 6px;
`;

const BookTitle = styled.div`
  font-size: 17px;
  font-weight: 700;
  color: #222;
  margin-bottom: 6px;
`;

const BookAuthor = styled.div`
  font-size: 15px;
  color: #888;
  margin-bottom: 2px;
`;

const StatusPairRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 56px;
  gap: 36px;
  margin: 18px 0 18px 24px;
`;

const StatusSelectHint = styled.div`
  font-size: 14px;
  color: #666;
  padding: 0 24px;
  margin-bottom: 8px;
`;

const StatusCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
`;

const StatusItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #bbb;
  cursor: pointer;
  &.active {
    color: #222;
    font-weight: 700;
  }
`;

const StatusIcon = styled.div`
  font-size: 28px;
  margin-bottom: 4px;
  color: inherit;
`;

const InfoTable = styled.div`
  background: #fff;
  border-radius: 0;
  margin: 0 24px 24px 24px;
  padding: 10px 0 32px 0;
  font-size: 15px;
  color: #222;
`;

const InfoRow = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 0 18px 0;
  cursor: pointer;
  &.with-line {
    border-bottom: 1px solid #eee;
  }
`;

const InfoLabel = styled.div`
  flex: 0 0 90px;
  color: #222;
  font-size: 14px;
  padding-left: 24px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const InfoValue = styled.div`
  flex: 1;
  color: #222;
  font-size: 15px;
  font-weight: 500;
  padding-right: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

const PageNumInput = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: #222;
  font-size: 15px;
  font-weight: 500;
  padding: 0;

  &::placeholder {
    color: #bbb;
    font-weight: 400;
  }
`;

const InfoLink = styled.a`
  color: #1976d2;
  text-decoration: underline;
  font-size: 15px;
  margin-left: 4px;
`;

const ArrowIcon = styled(FaChevronRight)`
  font-size: 13px;
  color: #bbb;
`;

const Selector = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: #555;
  font-weight: 500;
  cursor: pointer;
`;

const ClearDateButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-left: 6px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: #eee;
  color: #888;
  cursor: pointer;
  flex-shrink: 0;

  &:hover {
    background: #ddd;
    color: #555;
  }
`;

const MultiSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const MultiOption = styled.div`
  padding: 3px 10px;
  border-radius: 12px;
  background: #f5f5f7;
  color: #555;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  &.selected {
    background: #1976d2;
    color: #fff;
    border: 1px solid #1976d2;
  }
`;

const ContentContainer = styled.div`
  background: #fff;
  border-radius: 0;
  margin: 0;
  padding: 20px 0 24px 0;
`;

const ShelfSelector = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ShelfOption = styled.div`
  padding: 4px 12px;
  border-radius: 12px;
  background: #f5f5f7;
  color: #1976d2;
  font-size: 15px;
  font-weight: 500;
  border: 1px solid #e0e0e0;
  cursor: pointer;
  &.selected {
    background: #1976d2;
    color: #fff;
    border: 1px solid #1976d2;
  }
`;

const Dropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownButton = styled(Selector)`
  min-width: 80px;
  color: #555;
`;

const DropdownList = styled.div`
  position: absolute;
  left: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 10;
  min-width: 180px;
  padding-top: 8px;
  ${({ position }) => position === 'top' && 'bottom: 110%; top: auto;'}
  ${({ position }) => position === 'bottom' && 'top: 110%;'}
`;

const CloseButton = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  background: #f5f5f7;
  border: 1px solid #eee;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #666;
  font-size: 10px;
  transition: background-color 0.2s;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 11;
  
  &:hover {
    background: #e0e0e0;
  }
`;

const DropdownItem = styled.div`
  padding: 10px 18px;
  color: #555;
  font-size: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  &:hover {
    background: #f5f5f7;
  }
  &.selected {
    color: #1976d2;
    font-weight: 700;
  }
`;

const CheckIcon = styled(FaCheck)`
  font-size: 12px;
  color: #1976d2;
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
`;

const OwnershipDropdown = styled.div`
  position: absolute;
  left: 0;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  z-index: 20;
  padding: 8px 0;
  min-width: 180px;
  ${({ position }) => position === 'top' && 'bottom: 110%; top: auto;'}
  ${({ position }) => position === 'bottom' && 'top: 110%;'}
  visibility: ${props => props.visible ? 'visible' : 'hidden'};
`;

const RegisterButton = styled.button`
  display: block;
  width: 50%;
  margin: 32px auto 0 auto;
  background: #244AC2;
  color: #fff;
  font-size: 18px;
  border: none;
  border-radius: 24px;
  padding: 14px 0;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(36,74,194,0.08);
  transition: background 0.15s;
  &:active {
    background: #193a99;
  }
`;

const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #fff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
`;



const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 16px 20px;
  border-bottom: 1px solid #eee;
  background: #fff;
`;


const ModalTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #222;
`;




const ModalCloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s;
  
  &:hover {
    background: #f5f5f7;
  }
`;

const ModalContent = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export default function BookRegisterPage( {propIsbn, propBookId, onClose, isModify = false}) {
 
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const [isbn, setIsbn] = useState(propIsbn || params.get('isbn'));
  const [bookId, setBookId] = useState(propBookId || params.get('bookId'));
  
  // 책 정보 상태
  const [bookInfo, setBookInfo] = useState(null);
  const [bookcaseList, setBookcaseList] = useState([]);
  const [selectedBookcases, setSelectedBookcases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  
  // 기존 상태들
  const [shelf, setShelf] = useState('읽고싶은책');
  const [startDate, setStartDate] = useState('2024.12.08');
  const [endDate, setEndDate] = useState('2024.12.30');
  const [scriptStartDate, setScriptStartDate] = useState(null);
  const [scriptEndDate, setScriptEndDate] = useState(null);
  const [ownership, setOwnership] = useState('대여책');
  const ownershipOptions = Object.values(BookOwnership);
  const [pageNum, setPageNum] = useState('');
  const [search, setSearch] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('읽을책');
  const [selectedTranscribeStatus, setSelectedTranscribeStatus] = useState('필사할책');
  const [showShelfDropdown, setShowShelfDropdown] = useState(false);
  const shelfDropdownRef = useRef(null);
  const [showStartCal, setShowStartCal] = useState(false);
  const [showEndCal, setShowEndCal] = useState(false);
  const startCalRef = useRef(null);
  const endCalRef = useRef(null);
  const [showScriptStartCal, setShowScriptStartCal] = useState(false);
  const [showScriptEndCal, setShowScriptEndCal] = useState(false);
  const scriptStartCalRef = useRef(null);
  const scriptEndCalRef = useRef(null);
  const [showOwnershipDropdown, setShowOwnershipDropdown] = useState(false);
  const ownershipDropdownRef = useRef(null);
  const [ownershipDropdownPosition, setOwnershipDropdownPosition] = useState('bottom');
  const { showBack, setShowBack } = useNoobookContext();
  const [showResultModal, setShowResultModal] = useState(false);
  const invalidateSchedules = useInvalidateSchedules();
  // 날짜 선택 샘플
  //const dateOptions = ['2024.12.08', '2024.12.09', '2024.12.10', '2024.12.30'];
  useEffect(() => {
    const prevShowBack = showBack;
    setShowBack(true);
    return () => setShowBack(prevShowBack);
  }, []);
  // 책장 목록과 책 정보 로드
  useEffect(() => {
    const loadData = async () => {
      if (!(isbn || bookId) || loading) return;
      
      setLoading(true);
      try {
        const { accessToken } = await getAccessToken();
        
        // 책장 목록 로드
        const bookcaseResponse = await getBookcaseList(accessToken || '', null, null);
        const processedBookcaseResponse = processApiResponse(bookcaseResponse);
        
        if (!processedBookcaseResponse.success) {
          //alert(processedBookcaseResponse.errorMessage);
          setErrorMessage(processedBookcaseResponse.errorMessage);
          //navigate(0);
          return;
        }
        
        setBookcaseList(processedBookcaseResponse.data || []);
        
        // 책 정보 로드
        const bookResponse = isbn ? await getMyBookByIsbn(accessToken || '', isbn) : await getMyBookByBookId(accessToken || '', bookId);
        const processedBookResponse = processApiResponse(bookResponse);
        
        if (!processedBookResponse.success) {
          //alert(processedBookResponse.errorMessage);
          setErrorMessage(processedBookResponse.errorMessage);
          //navigate(-1);
          return;
        }
        
        const bookData = processedBookResponse.data;
        setBookInfo(bookData);
        
        // 책 상태 설정
        setSelectedStatus(bookData.bookStatus);
        setSelectedTranscribeStatus(bookData.scriptStatus);
        setOwnership(bookData.ownership);
        setPageNum(bookData.pageNum != null && bookData.pageNum !== '' ? String(bookData.pageNum) : '');

        
        
        // 독서 기간 설정 (9999-09-09 는 미입력으로 취급)
        setStartDate(formatDateValue(bookData.readFr ? new Date(bookData.readFr) : null));
        setEndDate(formatDateValue(bookData.readTo ? new Date(bookData.readTo) : null));
        setScriptStartDate(formatDateValue(bookData.scriptFr ? new Date(bookData.scriptFr) : null));
        setScriptEndDate(formatDateValue(bookData.scriptTo ? new Date(bookData.scriptTo) : null));
        
        // 선택된 책장 설정
        if (bookData.bookcases && Array.isArray(bookData.bookcases)) {
          setSelectedBookcases(bookData.bookcases.map(bc => bc.id).filter(id => id !== null));
        }
      } catch (error) {
        console.error('데이터 로드 중 오류:', error);
        //alert('네트워크 오류가 발생했습니다. 다시 시도해 주세요.');
        setErrorMessage('네트워크 오류가 발생했습니다. 다시 시도해 주세요.');
        //navigate(-1);
      } finally {
        setLoading(false);
      }
    };
    
    loadData();
  }, [isbn, bookId]);

  // 책장 선택/해제 처리
  const handleBookcaseToggle = (bookcaseId) => {
    setSelectedBookcases(prev => {
      if (prev.includes(bookcaseId)) {
        return prev.filter(id => id !== bookcaseId);
      } else {
        return [...prev, bookcaseId];
      }
    });
  };

  // 드롭다운 외부 클릭 시 닫기
  React.useEffect(() => {
    function handleClick(e) {
      if (shelfDropdownRef.current && !shelfDropdownRef.current.contains(e.target)) {
        setShowShelfDropdown(false);
      }
      if (showStartCal && startCalRef.current && !startCalRef.current.contains(e.target)) setShowStartCal(false);
      if (showEndCal && endCalRef.current && !endCalRef.current.contains(e.target)) setShowEndCal(false);
      if (showScriptStartCal && scriptStartCalRef.current && !scriptStartCalRef.current.contains(e.target)) setShowScriptStartCal(false);
      if (showScriptEndCal && scriptEndCalRef.current && !scriptEndCalRef.current.contains(e.target)) setShowScriptEndCal(false);
      if (showOwnershipDropdown && ownershipDropdownRef.current && !ownershipDropdownRef.current.contains(e.target)) {
        setShowOwnershipDropdown(false);
      }
    }
    if (showShelfDropdown || showStartCal || showEndCal || showScriptStartCal || showScriptEndCal || showOwnershipDropdown) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
    return () => document.removeEventListener('mousedown', handleClick);
  }, [showShelfDropdown, showStartCal, showEndCal, showScriptStartCal, showScriptEndCal, showOwnershipDropdown]);

  // 소유권 드롭다운 위치 계산
  const handleOwnershipDropdown = () => {
    if (!ownershipDropdownRef.current) return setShowOwnershipDropdown(v => !v);
    const rect = ownershipDropdownRef.current.getBoundingClientRect();
    const popupHeight = 210;
    if (window.innerHeight - rect.bottom < popupHeight) {
      setOwnershipDropdownPosition('top');
    } else {
      setOwnershipDropdownPosition('bottom');
    }
    setShowOwnershipDropdown(v => !v);
  };

  // 책 상태 클릭 핸들러 (토글 기능)
  const handleBookStatusClick = (status) => {
    setSelectedStatus(selectedStatus === status ? null : status);
  };

  // 필사 상태 클릭 핸들러 (토글 기능)
  const handleScriptStatusClick = (status) => {
    setSelectedTranscribeStatus(selectedTranscribeStatus === status ? null : status);
  };


  const handleSearch = () => {
    if (onClose) {
      //onClose(isbn, bookId);
      setShowResultModal(true);
    } else {
    if (search.trim()) {
      navigate(`/book-search-result?keyword=${encodeURIComponent(search.trim())}&bookRegType=${BookRegType.NUBOOK}`);
    }
  }
  };



  const closeResultModal = (argIsbn, argBookId) => {
    setShowResultModal(false); 
    console.log('argIsbn', argIsbn, 'argBookId', argBookId);
    if(argIsbn) {
      setIsbn(argIsbn);
    }
    if(argBookId) {
      setBookId(argBookId);
    }
  };


  



  // 등록하기 버튼 클릭 핸들러
  const handleRegister = async () => {
    if (loading) return;
    if (!isbn && !bookId) {
      alert('ISBN/책ID 정보가 없습니다.');
      return;
    }

    // 책장 선택 검증
    if (!selectedBookcases || selectedBookcases.length === 0) {
      alert('책장은 최소 1개 이상 선택해야 합니다.');
      return;
    }

    setLoading(true);
    try {
      const { accessToken } = await getAccessToken();
      
      // BookUserInputReqDTO 객체 생성
      const bookUserInputReqDTO = new BookUserInputReqDTO();
      bookUserInputReqDTO.bookId = bookInfo?.bookId || null;
      bookUserInputReqDTO.userId = bookInfo?.userId || null;
      bookUserInputReqDTO.ownership = ownership;
      bookUserInputReqDTO.bookStatus = selectedStatus;
      bookUserInputReqDTO.scriptStatus = selectedTranscribeStatus;
      bookUserInputReqDTO.score = null; // 점수는 별도 입력 필요시 추가
      const parsedPageNum = pageNum === '' ? null : parseInt(pageNum, 10);
      bookUserInputReqDTO.pageNum = Number.isNaN(parsedPageNum) ? null : parsedPageNum;
      bookUserInputReqDTO.readPage = null; // 읽은 페이지는 별도 입력 필요시 추가
      bookUserInputReqDTO.readFr = startDate ? stringToDate(startDate, 'yyyy.mm.dd', '.') : null;
      bookUserInputReqDTO.readTo = endDate ? stringToDate(endDate, 'yyyy.mm.dd', '.') : null;
      bookUserInputReqDTO.scriptFr = scriptStartDate ? stringToDate(scriptStartDate, 'yyyy.mm.dd', '.') : null; // 필사 시작일은 별도 입력 필요시 추가
      bookUserInputReqDTO.scriptTo = scriptEndDate ? stringToDate(scriptEndDate, 'yyyy.mm.dd', '.') : null; // 필사 종료일은 별도 입력 필요시 추가
      bookUserInputReqDTO.bookcases = selectedBookcases;

      //console.log('startDate', stringToDate(startDate, 'yyyy.mm.dd', '.'), 'endDate', stringToDate(endDate, 'yyyy.mm.dd', '.'), 'scriptStartDate', stringToDate(scriptStartDate, 'yyyy.mm.dd', '.'), 'scriptEndDate', stringToDate(scriptEndDate, 'yyyy.mm.dd', '.'));
      //console.log('bookUserInputReqDTO', bookUserInputReqDTO);

      // API 호출
      const response = isbn ? await putMyBookByIsbn(accessToken || '', isbn, bookUserInputReqDTO) : await putMyBookByBookId(accessToken || '', bookId, bookUserInputReqDTO);
      const processedResponse = processApiResponse(response);
      
      if (processedResponse.success) {
        alert('등록하였습니다.');
        invalidateSchedules();
        if (onClose) {
          onClose(true);
        } else {
          navigate(-1); // 이전 페이지로 이동
        }
      } else {
        alert(processedResponse.errorMessage || '등록에 실패했습니다.');
      }
    } catch (error) {
      console.error('등록 중 오류:', error);
      alert('네트워크 오류가 발생했습니다. 다시 시도해 주세요.');
    } finally {
      setLoading(false);
    }
  };







  if (errorMessage.length > 0) {
    return (
      <>
        <Wrapper>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '60vh',
            padding: '20px',
            textAlign: 'center'
          }}>
            
            <div style={{
              fontSize: '16px',
              color: '#666',
              marginBottom: '30px',
              lineHeight: '1.5'
            }}>
              {errorMessage}
            </div>
            <button
              onClick={() => onClose ? onClose(false) : navigate(-1)}
              style={{
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => e.target.style.background = '#1565c0'}
              onMouseOut={(e) => e.target.style.background = '#1976d2'}
            >
              뒤로 가기
            </button>
          </div>
        </Wrapper>
        {/*<BottomTab selected="home" />*/}
      </>
    );
  }

  return (
    <>
      {/*<TopNav showBack />*/}
      <Wrapper>
        {!isModify && <BookSearchHeader
          title="어떤 책을 찾으시나요?"
          placeholder="책, 저자, 출판사를 검색해 보세요"
          value={search}
          onChange={e => setSearch(e.target.value)}
          onSearch={handleSearch}
        />}
        {loading ? (
          <div style={{textAlign: 'center', padding: '50px', color: '#888'}}>
            책 정보를 불러오는 중...
          </div>
        ) : (
          <ContentContainer>
            <BookInfoSection>
              <BookCoverImage
                src={bookInfo?.cover}
                alt={bookInfo?.title}
                width={90}
                height={126}
                borderRadius={6}
                boxShadow="0 2px 8px rgba(0,0,0,0.08)"
                marginRight={18}
                fontSize={11}
              />
              <BookMeta>
                <BookTitle>{bookInfo?.title || "책 제목"}</BookTitle>
                <BookAuthor>{bookInfo?.author || "저자"}</BookAuthor>
              </BookMeta>
            </BookInfoSection>
            <StatusSelectHint>* 이 책의 상태를 선택해 주세요.</StatusSelectHint>
            <StatusPairRow>
              <StatusCol>
                <StatusItem className={selectedStatus && selectedStatus.toUpperCase() === BookStatus.READING ? 'active' : ''} onClick={() => handleBookStatusClick(BookStatus.READING)}>
                  <StatusIcon><FiBookOpen /></StatusIcon>
                  {bookStatus2text(BookStatus.READING)}
                </StatusItem>
                <StatusItem className={selectedTranscribeStatus && selectedTranscribeStatus.toUpperCase() === ScriptStatus.SCRIPTING ? 'active' : ''} onClick={() => handleScriptStatusClick(ScriptStatus.SCRIPTING)}>
                  <StatusIcon><FiEdit2 /></StatusIcon>
                  {scriptStatus2text(ScriptStatus.SCRIPTING)}
                </StatusItem>
              </StatusCol>
              <StatusCol>
                <StatusItem className={selectedStatus && selectedStatus.toUpperCase() === BookStatus.PLAN_TO_READ ? 'active' : ''} onClick={() => handleBookStatusClick(BookStatus.PLAN_TO_READ)}>
                  <StatusIcon><FiBook /></StatusIcon>
                  {bookStatus2text(BookStatus.PLAN_TO_READ)}
                </StatusItem>
                <StatusItem className={selectedTranscribeStatus && selectedTranscribeStatus.toUpperCase() === ScriptStatus.PLAN_TO_SCRIPT ? 'active' : ''} onClick={() => handleScriptStatusClick(ScriptStatus.PLAN_TO_SCRIPT)}>
                  <StatusIcon><FiEdit /></StatusIcon>
                  {scriptStatus2text(ScriptStatus.PLAN_TO_SCRIPT)}
                </StatusItem>
              </StatusCol>
              <StatusCol>
                <StatusItem className={selectedStatus && selectedStatus.toUpperCase() === BookStatus.DONE_TO_READ ? 'active' : ''} onClick={() => handleBookStatusClick(BookStatus.DONE_TO_READ)}>
                  <StatusIcon><PiBooks /></StatusIcon>
                  {bookStatus2text(BookStatus.DONE_TO_READ)}
                </StatusItem>
                <StatusItem className={selectedTranscribeStatus && selectedTranscribeStatus.toUpperCase() === ScriptStatus.DONE_TO_SCRIPT ? 'active' : ''} onClick={() => handleScriptStatusClick(ScriptStatus.DONE_TO_SCRIPT)}>
                  <StatusIcon><FiEdit3 /></StatusIcon>
                  {scriptStatus2text(ScriptStatus.DONE_TO_SCRIPT)}
                </StatusItem>
              </StatusCol>
            </StatusPairRow>
            <StatusSelectHint>* 책장을 한 개 이상 선택해 주세요.</StatusSelectHint>
            <InfoTable>
              <InfoRow className="with-line">
                <InfoLabel>책장<ArrowIcon /></InfoLabel>
                <InfoValue>
                  <Dropdown ref={shelfDropdownRef}>
                    <DropdownButton onClick={() => setShowShelfDropdown(v => !v)}>
                      {selectedBookcases.length > 0 
                        ? `${selectedBookcases.length}개 선택됨`
                        : '책장 선택'
                      }
                    </DropdownButton>
                    {showShelfDropdown && (
                      <DropdownList>
                        {bookcaseList.map(opt => (
                          <DropdownItem
                            key={opt.id}
                            className={selectedBookcases.includes(opt.id) ? 'selected' : ''}
                            onClick={() => {
                              handleBookcaseToggle(opt.id);
                              // setShowShelfDropdown(false); // 이 줄을 제거하여 클릭 시 닫히지 않도록 함
                            }}
                          >
                            <CheckIcon visible={selectedBookcases.includes(opt.id)} />
                            {opt.name}
                          </DropdownItem>
                        ))}
                        <CloseButton onClick={() => setShowShelfDropdown(false)}>
                          <FaTimes />
                        </CloseButton>
                      </DropdownList>
                    )}
                  </Dropdown>
                </InfoValue>
              </InfoRow>
              <InfoRow className="with-line">
                <InfoLabel>독서시작<ArrowIcon /></InfoLabel>
                <InfoValue>
                  <div style={{position:'relative', display:'flex', alignItems:'center'}} ref={startCalRef}>
                    <Selector onClick={() => setShowStartCal(v => !v)}>{isEmptyDate(startDate) ? '독서시작일 선택' : startDate}</Selector>
                    {!isEmptyDate(startDate) && (
                      <ClearDateButton
                        type="button"
                        aria-label="독서시작일 초기화"
                        onClick={(e) => {
                          e.stopPropagation();
                          setStartDate(CLEARED_DATE_STR);
                          setShowStartCal(false);
                        }}
                      >
                        <FaTimes size={11} />
                      </ClearDateButton>
                    )}
                    {showStartCal && (
                      <SimpleCalendar
                        value={isEmptyDate(startDate) ? null : startDate}
                        onSelect={(date) => {console.log('date', date); setStartDate(date)}}
                        onClose={() => setShowStartCal(false)}
                        anchorRef={startCalRef}
                      />
                    )}
                  </div>
                </InfoValue>
              </InfoRow>
              <InfoRow className="with-line">
                <InfoLabel>독서종료<ArrowIcon /></InfoLabel>
                <InfoValue>
                  <div style={{position:'relative', display:'flex', alignItems:'center'}} ref={endCalRef}>
                    <Selector onClick={() => setShowEndCal(v => !v)}>{isEmptyDate(endDate) ? '독서종료일 선택' : endDate}</Selector>
                    {!isEmptyDate(endDate) && (
                      <ClearDateButton
                        type="button"
                        aria-label="독서종료일 초기화"
                        onClick={(e) => {
                          e.stopPropagation();
                          setEndDate(CLEARED_DATE_STR);
                          setShowEndCal(false);
                        }}
                      >
                        <FaTimes size={11} />
                      </ClearDateButton>
                    )}
                    {showEndCal && (
                      <SimpleCalendar
                        value={isEmptyDate(endDate) ? null : endDate}
                        onSelect={setEndDate}
                        onClose={() => setShowEndCal(false)}
                        anchorRef={endCalRef}
                      />
                    )}
                  </div>
                </InfoValue>
              </InfoRow>
              <InfoRow className="with-line">
                <InfoLabel>필사시작<ArrowIcon /></InfoLabel>
                <InfoValue>
                  <div style={{position:'relative', display:'flex', alignItems:'center'}} ref={scriptStartCalRef}>
                    <Selector onClick={() => setShowScriptStartCal(v => !v)}>{isEmptyDate(scriptStartDate) ? '필사시작일 선택' : scriptStartDate}</Selector>
                    {!isEmptyDate(scriptStartDate) && (
                      <ClearDateButton
                        type="button"
                        aria-label="필사시작일 초기화"
                        onClick={(e) => {
                          e.stopPropagation();
                          setScriptStartDate(CLEARED_DATE_STR);
                          setShowScriptStartCal(false);
                        }}
                      >
                        <FaTimes size={11} />
                      </ClearDateButton>
                    )}
                    {showScriptStartCal && (
                      <SimpleCalendar
                        value={isEmptyDate(scriptStartDate) ? null : scriptStartDate}
                        onSelect={setScriptStartDate}
                        onClose={() => setShowScriptStartCal(false)}
                        anchorRef={scriptStartCalRef}
                      />
                    )}
                  </div>
                </InfoValue>
              </InfoRow>
              <InfoRow className="with-line">
                <InfoLabel>필사종료<ArrowIcon /></InfoLabel>
                <InfoValue>
                  <div style={{position:'relative', display:'flex', alignItems:'center'}} ref={scriptEndCalRef}>
                    <Selector onClick={() => setShowScriptEndCal(v => !v)}>{isEmptyDate(scriptEndDate) ? '필사종료일 선택' : scriptEndDate}</Selector>
                    {!isEmptyDate(scriptEndDate) && (
                      <ClearDateButton
                        type="button"
                        aria-label="필사종료일 초기화"
                        onClick={(e) => {
                          e.stopPropagation();
                          setScriptEndDate(CLEARED_DATE_STR);
                          setShowScriptEndCal(false);
                        }}
                      >
                        <FaTimes size={11} />
                      </ClearDateButton>
                    )}
                    {showScriptEndCal && (
                      <SimpleCalendar
                        value={isEmptyDate(scriptEndDate) ? null : scriptEndDate}
                        onSelect={setScriptEndDate}
                        onClose={() => setShowScriptEndCal(false)}
                        anchorRef={scriptEndCalRef}
                      />
                    )}
                  </div>
                </InfoValue>
              </InfoRow>


              <InfoRow className="with-line">
                <InfoLabel>소유권<ArrowIcon /></InfoLabel>
                <InfoValue>
                  <Dropdown ref={ownershipDropdownRef}>
                    <DropdownButton onClick={handleOwnershipDropdown}>
                      {ownership ? ownership2text(ownership) : '선택'}
                    </DropdownButton>
                    {showOwnershipDropdown && (
                      <DropdownList position={ownershipDropdownPosition}>
                        {ownershipOptions.map(opt => (
                          <DropdownItem
                            key={opt}
                            className={ownership && ownership.toUpperCase() === opt.toUpperCase() ? 'selected' : ''}
                            onClick={() => {
                              setOwnership(opt);
                              setShowOwnershipDropdown(false);
                            }}
                          >
                            {ownership2text(opt)}
                          </DropdownItem>
                        ))}
                      </DropdownList>
                    )}
                  </Dropdown>
                </InfoValue>
              </InfoRow>
              <InfoRow>
                <InfoLabel>총페이지</InfoLabel>
                <InfoValue>
                  <PageNumInput
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    placeholder="총페이지 입력"
                    value={pageNum}
                    onClick={(e) => e.stopPropagation()}
                    onKeyDown={(e) => {
                      if (e.key.length === 1 && !/[0-9]/.test(e.key) && !e.ctrlKey && !e.metaKey) {
                        e.preventDefault();
                      }
                    }}
                    onChange={(e) => {
                      const digitsOnly = e.target.value.replace(/\D/g, '');
                      setPageNum(digitsOnly);
                    }}
                  />
                </InfoValue>
              </InfoRow>
              <RegisterButton onClick={handleRegister}>
                {bookInfo?.id ? '수정하기' : '등록하기'}
              </RegisterButton>
            </InfoTable>
          </ContentContainer>
        )}
        {/* 검색 결과 모달 */}
        {showResultModal && (
         <Modal>
           <ModalHeader>
             <ModalTitle>검색 결과</ModalTitle>
             <ModalCloseButton onClick={()=>closeResultModal(null, null)}>
               <FaTimes />
             </ModalCloseButton>
           </ModalHeader>
           <ModalContent>
             <BookSearchResultPage 
               keyword={search} 
               onClose={closeResultModal}
             />
           </ModalContent>
         </Modal>
       )}
      </Wrapper>
      {loading && <LoadingOverlay />}
    </>
  );
} 